import { css } from '@emotion/react'
import { Component } from 'react'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import { SharedModal, Loading } from './'
import { ModalActions, ModalConfirmButton, ModalCancelButton } from './ModalActions'

const PlanOffersText = styled.div`
  color: #4a606a;
  font-size: 1.125rem;
  line-height: 33px;
  word-wrap: break-word;
  overflow-wrap: break-word;
`

class PlanOffersOptionModal extends Component {
  static propTypes = {
    isModalOpen: PropTypes.bool,
    toggleModal: PropTypes.func,
    title: PropTypes.string,
    handleConfirmation: PropTypes.func,
    error: PropTypes.bool,
    loading: PropTypes.bool,
  }

  render() {
    const {
      handleConfirmation,
      handleNotOffered,
      handleCancel,
      isModalOpen,
      title = 'Delete This Information',
      error,
      loading,
    } = this.props

    return (
      <SharedModal isModalOpen={isModalOpen} title={title} toggleModal={handleCancel}>
        <PlanOffersText />
        {error && (
          <div
            css={css`
              color: #e31e27;
              font-size: 14px;
              line-height: 1.5;
              text-align: center;
              padding: 0.25rem 0 0.75rem 0;
            `}>
            Something went wrong, please try again later.
          </div>
        )}
        {loading ? (
          <Loading />
        ) : (
          <ModalActions>
            <ModalCancelButton type='button' onClick={handleNotOffered}>
              No
            </ModalCancelButton>
            <ModalConfirmButton type='button' onClick={handleConfirmation}>
              Yes / Not sure
            </ModalConfirmButton>
          </ModalActions>
        )}
      </SharedModal>
    )
  }
}

export default PlanOffersOptionModal
